<script lang="ts">
    import type {Fond} from 'typings/portaro.be.types';
    import {RecordGridService} from 'src/features/record-grid/services/record-grid.service';
    import {getInjector} from 'core/svelte-context/context';
    import {getSutorReportsOptimisationContext} from '../lib/sutor-reports-optimisation-context';
    import KpRecordGridDisplay from 'src/features/record-grid/KpRecordGridDisplay.svelte';
    import KpLoadingBlock from 'shared/components/kp-loading/KpLoadingBlock.svelte';
    import KpStaticSearchContext from 'src/features/search/kp-search-context/KpStaticSearchContext.svelte';

    export let fond: Fond;

    const recordGridService = getInjector().getByClass(RecordGridService);
    const context = getSutorReportsOptimisationContext();

    async function loadStaticData(optimisationFond: Fond) {
        return Promise.all([
            recordGridService.loadLayout(optimisationFond),
            recordGridService.loadInsertableFonds(optimisationFond)
        ]);
    }
</script>

<KpStaticSearchContext searchManager="{context.optimisationTableSearchContext}">
    {#await loadStaticData(fond)}
        <KpLoadingBlock size="sm"/>
    {:then [gridLayout, insertableFonds]}
        <KpRecordGridDisplay {fond}
                             {gridLayout}
                             {insertableFonds}
                             includeAddNewRow>
        </KpRecordGridDisplay>
    {/await}
</KpStaticSearchContext>